import React, { Component } from 'react';
import {
  HashRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Redirect } from 'react-router';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import AuthenticateUser from './AuthenticateUser.js'
import { saveActivity } from '../common/commonService.js'
import IconMenu from 'material-ui/IconMenu';


class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      access: JSON.parse(localStorage.getItem('userRole')),
      loginRedirect: false,
      name: localStorage.getItem('name'),
      location: '/'
    };
    this.handleToggle = this.handleToggle.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.logout = this.logout.bind(this)
  }
  handleToggle() { this.setState({ open: true }); }
  handleClose() { this.setState({ open: false }); }
  logout() {
    if (localStorage.getItem('token') && localStorage.getItem('activityTrack')) {
      let activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
      localStorage.removeItem('activityTrack');
      if(activityTrack && activityTrack.length > 0) {
        activityTrack.map(act => saveActivity(act))
      }
    }
    const loginPath = localStorage.getItem('loggedInType')
    const activity_tracking_token = localStorage.getItem('activity_tracking_token')
    localStorage.clear()
    localStorage.setItem("activity_tracking_token",activity_tracking_token)
    AuthenticateUser.isAuthenticated = false
    if (loginPath === 'MyGame') this.setState({ location: '/mygamelogin' })
    else if (loginPath === 'PartyPoker') this.setState({ location: '/' })
    this.setState({ loginRedirect: true })
  }

  // render() {
  //   return (
  //     <div>
  //       {this.state.loginRedirect && (
  //         <Redirect to={this.state.location} />
  //       )}
  //       <AppBar style={{ backgroundColor: '#1F1E23', position: 'fixed', borderBottom: '2px solid #DE460F' }} titleStyle={{ color: 'white' }} title={this.props.title} iconStyleRight={{ color: 'white' }} iconStyleLeft={{ color: 'white' }} iconElementLeft={<IconButton iconStyle={{ color: 'white' }} iconClassName="fa fa-bars" onClick={this.handleToggle}></IconButton>} iconElementRight={<RightMenu name={this.state.name} logout={this.logout} />} />

  //       <Drawer open={this.state.open} docked={false} onRequestChange={(open) => this.setState({ open })}>
  //         {this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('BUSINESS_OWNER') != -1 || this.state.access.indexOf('COACH') !== -1
  //           ? <Link to="/pokerWatch"><MenuItem onTouchTap={this.handleClose}>Poker Watch</MenuItem></Link>
  //           : null}
  //         {this.state.access.indexOf('SYS_ADMIN') !== -1 || this.state.access.indexOf('BUSINESS_OWNER') !== -1
  //           ? <div>
  //             <Link to="/appUserComp">
  //               <MenuItem onTouchTap={this.handleClose} >
  //                 Users
  //                     </MenuItem>
  //             </Link>
  //             <Link to="/tournamenttype">
  //               <MenuItem onTouchTap={this.handleClose} >
  //                 Tournament Type
  //                     </MenuItem>
  //             </Link>
  //             <Link to="/tournamentwatch">
  //               <MenuItem onTouchTap={this.handleClose} >
  //                 Tournament Watch (MTT)
  //                     </MenuItem>
  //             </Link>
  //           </div>
  //           : null}
  //         {this.state.access.indexOf('SYS_ADMIN') !== -1
  //           ? <div>
  //             <Link to="/businessList"><MenuItem onTouchTap={this.handleClose} >Business Master</MenuItem></Link>
  //             <Link to="/promotionalContent/list"><MenuItem onTouchTap={this.handleClose}>Promotional Content</MenuItem></Link>
  //             <Link to="/moduleNlessonList"><MenuItem onTouchTap={this.handleClose}>Modules/Lessons</MenuItem></Link>
  //             <Link to="/newContent"><MenuItem onTouchTap={this.handleClose}>Lesson Content</MenuItem></Link>
  //           </div>
  //           : null}
  //         {this.state.access.indexOf('PLAYER') !== -1
  //           ? <Link to="/myReportCard"><MenuItem onTouchTap={this.handleClose} >My Report Card</MenuItem></Link>
  //           : null}
  //         {this.state.access.indexOf('SYS_ADMIN') != -1 || this.state.access.indexOf('SHIFT_MANAGER') != -1 || this.state.access.indexOf('PLAYER') != -1 || this.state.access.indexOf('COACH') !== -1
  //           ? <Link to="/course"><MenuItem onTouchTap={this.handleClose}>Course</MenuItem></Link>
  //           : null}
  //         <Link to="/changePwd"><MenuItem onTouchTap={this.handleClose}>Change Password</MenuItem></Link>
  //         {/* <Link to="/"><MenuItem onTouchTap={this.logout}>Logout</MenuItem></Link> */}
  //         {/* <MenuItem onTouchTap={this.logout}>Logout</MenuItem> */}
  //       </Drawer>

  //       <br /><br /><br />

  //     </div>


  //   )
  // }
  render() {
    return(<div/>)
  }
}

const RightMenu = (props) => (
  <IconMenu
    {...props}
    iconButtonElement={
      <FlatButton style={{ color: 'white', marginTop: '5px' }} label={props.name} />
    }
    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
  >
    <MenuItem onTouchTap={props.logout} primaryText="Logout" />
  </IconMenu>
);



export default Menu;



/** WEBPACK FOOTER **
 ** ./src/components/Menu.js
 **/